import { create } from 'zustand';
import type { Project } from '../types';

interface ProjectState {
  // State
  currentProject: Project | null;
  projects: Project[];
  rootId: string;

  // Actions
  setCurrentProject: (project: Project | null) => void;
  setProjects: (projects: Project[]) => void;
  setRootId: (id: string) => void;
  selectProject: (project: Project) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  // Initial state
  currentProject: null,
  projects: [],
  rootId: '',

  // Actions
  setCurrentProject: (currentProject) => set({ currentProject }),
  setProjects: (projects) => set({ projects }),
  setRootId: (rootId) => set({ rootId }),

  selectProject: (project) =>
    set({
      currentProject: project,
    }),
}));
